import { CLEAR_RESULT, FETCH_RESULT_SUCCESS, FETCH_RESULT_FAILURE } from './actions'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case CLEAR_RESULT:
      return {}

    case FETCH_RESULT_SUCCESS:
      return action.result

    case FETCH_RESULT_FAILURE:
      return action.error

    default:
      return state
  }
}
